import { z } from "zod"

export const QuickCreateCommunicationTemplateFormSchema = z.object({
  subject: z.string().min(1, "Subject is required").max(255),
  content: z.string().min(1, "Content is required"),
})

export type QuickCreateCommunicationTemplateFormData = z.infer<
  typeof QuickCreateCommunicationTemplateFormSchema
>
